import { GROUPED_STATIC_TEXT_ROLE } from '../../../../../ui-components/NameValueTableRow'

export const BrokePowerOfRebalancingPointer = () => {
  return (
    <div className='flex flex-col'>
      <div className='flex flex-col gap-1'>
        <h3
          role={GROUPED_STATIC_TEXT_ROLE}
          aria-label='Power Rebalancing'
          className='text-sm font-medium text-[#992E00] mb-1 m-0'
        >
          <span aria-hidden='true'>Power Rebalancing</span>
        </h3>
        <h4
          role={GROUPED_STATIC_TEXT_ROLE}
          aria-label='Portfolio reviews by SEBI-regd. advisors'
          className='text-base font-medium text-grey10 m-0'
        >
          <span aria-hidden='true'>Portfolio reviews by SEBI-regd. advisors</span>
        </h4>
        <div
          role={GROUPED_STATIC_TEXT_ROLE}
          aria-label='Your portfolio is reviewed every month to create a tax-optimised rebalancing plan. Recommendations are only made when the benefits outweigh the tax impact.'
          className='text-sm text-grey40'
        >
          <span aria-hidden='true'>
            Your portfolio is reviewed every month to create a tax-optimised rebalancing plan. Recommendations are only
            made when the benefits outweigh the tax impact.
          </span>
        </div>
        <div className='flex flex-row justify-center items-center my-5'>
          <img
            className='w-full h-auto'
            src='/images/elite/power_rebalancing_elite.png'
            alt='Illustration of portfolio rebalancing'
          />
        </div>
      </div>
    </div>
  )
}
